module.exports = __webpack_public_path__ + "img/askbuzz-transparent.c3fd8f1e.png";